import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { map } from 'rxjs';

export function authenticationGuard(): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const authService: AuthService = inject(AuthService);
    const router: Router = inject(Router);

    return authService
      .validate()
      .pipe(map(isValid => (isValid ? isValid : router.createUrlTree([`/auth/login`], { queryParams: { returnUrl: state.url }}))));
  };
}
